import type { ReactNode } from 'react';
import stile from './auth-rahmen.module.css';

/** Anmelden und zweiter Faktor liegen ausserhalb der Shell; die Karte gibt ihnen die Marke. */
export function AuthRahmen({ children }: { children: ReactNode }) {
  return (
    <main className={stile.flaeche}>
      <div className={stile.karte}>
        <div className={stile.marke}>
          <img src="/marke/ergo-logo.png" alt="ERGO" className={stile.logo} />
          <span className={stile.trenner} aria-hidden="true" />
          <span className={stile.produkt}>Content Engine</span>
        </div>
        {children}
      </div>
    </main>
  );
}
